export default __webpack_public_path__ + "static/customer-segmentation-d25c5cfeb527c7078f55a8ec45db64bd.svg";